import { Component, Input, OnInit, Output } from '@angular/core';
import { IDailyReportDisplayModel, IReportDisplayModel } from '../../../../models/daily-report-display.model';
import { SharedService } from '../../../../services/shared.service';
import { LiaisonApiService } from '../../../../../../app/features/liaison/services/liaison-api-service';
import { IIssue } from '../../../../../../app/features/liaison/models/daily-report.model';

@Component({
    selector: 'issue-list-component',
    templateUrl: 'issue-list.component.html',
    styleUrls:['./issue-list.component.scss'],
    providers: [LiaisonApiService]
})

export class IssueListComponent implements OnInit {
    
    @Input() issues: IIssue[] = [];

    statusMap = new Map<string, string>([
        ['new', 'New Issue'],
        ['update', 'In Progress'],
        ['closed', 'Closed']
    ])

    statusColorMap = new Map<string, string>([
        ['new', '#0568af'],
        ['update', 'lightgrey'],
        ['closed', '#c1272d']
    ])

    getRandomDateThisWeek(lowerRange = 0, upperRange = 6) {
        const now = new Date();
        
        // Get current day (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const currentDayOfWeek = now.getDay();
        
        // Get the start of the week (Sunday)
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - currentDayOfWeek);
        startOfWeek.setHours(0, 0, 0, 0); // Set time to 00:00:00 for start of day
    
        // Ensure the ranges are within the valid bounds (0-6)
        lowerRange = Math.max(0, lowerRange);
        upperRange = Math.min(6, upperRange);
    
        // Get the lower bound date and upper bound date
        const lowerBoundDate = new Date(startOfWeek);
        lowerBoundDate.setDate(startOfWeek.getDate() + lowerRange);
    
        const upperBoundDate = new Date(startOfWeek);
        upperBoundDate.setDate(startOfWeek.getDate() + upperRange);
    
        // Generate a random timestamp between the lower and upper bounds
        const randomTimestamp = Math.random() * (upperBoundDate.getTime() - lowerBoundDate.getTime()) + lowerBoundDate.getTime();
        
        // Create a random date object
        const randomDate = new Date(randomTimestamp);
    
        // Format the date as MM/DD/YYYY
        const month = String(randomDate.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
        const day = String(randomDate.getDate()).padStart(2, '0');
        const year = randomDate.getFullYear();
    
        // Return the date in the format MM/DD/YYYY
        return `${month}/${day}/${year}`;
    }

    getDateDaysAgo(daysAgo: number, issue: IIssue, issueUpdate?: any) {
        // If date created is created than 06/01/2024, it is new demo data and should use the date created
        if (issue.date_created && new Date(issue.date_created) > new Date('2024-06-01')) {
            if (issueUpdate) {
                return issueUpdate.time_created?.replace('-', '/')?.replace('-', '/') ?? issue.date_created;
            }

            return issue.date_created;
        }


        // Get the current date
        const now = new Date();
        
        // Subtract the number of days from the current date
        const targetDate = new Date(now);
        targetDate.setDate(now.getDate() - daysAgo);
    
        // Format the date as MM/DD/YYYY
        const month = String(targetDate.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
        const day = String(targetDate.getDate()).padStart(2, '0');
        const year = targetDate.getFullYear();
    
        // Return the formatted date
        return `${month}/${day}/${year}`;
    }

    ngOnInit(): void {
        console.log(this.issues)
        if (this.issues) {
            this.issues.forEach(issue => {
                // format date
                if (issue.date_created?.includes('T')) {
                    const [year, month, day] = issue.date_created.split('T')[0].split('-');

                    issue.date_created = `${month}/${day}/${year}`
                }

                if (!(issue as any).status) {
                    var status = 'new';

                    if (!issue.active) {
                        status = 'closed';
                    } else if (issue.issue_updates.filter(u => !u.is_action_taken).length > 0) {
                        status = 'update';
                    }

                    (issue as any).status = status;
                }

                issue.issue_updates.forEach(update => {
                    if (update.time_created) {
                        // update.time_created = update.time_created.replace('-', '/').replace('-', '/');
                    }

                    if (update.id === issue.actionUpdate?.id || update.is_action_taken) {
                        (issue.actionUpdate as any) = update;
                        update.dontShow = true;
                    }

                    if (update.is_closing_update) {
                        update.dontShow = true;

                        issue.closing_update = update;
                    }

                    // if (update.content) {
                    //     var optionalSentenceOne = null;
                    //     var optionalSentenceTwo = null;
                    //     var optionalSentenceThree = null;

                    //     if (update.parts_found) {
                    //         optionalSentenceOne = `${update.parts_found} parts found `;
                    //     }

                    //     if (update.area_found && optionalSentenceOne) {
                    //         optionalSentenceOne += `in ${update.area_found}. `;
                    //     }

                    //     if (update.area_found && !optionalSentenceOne) {
                    //         optionalSentenceOne = `Issue found in ${update.area_found}`;
                    //     }

                    //     if (update.issue_serial_numbers.length > 0 && (update.issue_serial_numbers as any) !== 'none') {
                    //         optionalSentenceTwo = `Traceability Barcodes: ${update.issue_serial_numbers}. `
                    //     }

                    //     if (update.clean_point_required) {
                    //         optionalSentenceThree = `Clean point: ${update.clean_point_date}. `
                    //     }

                    //     update.content = `${optionalSentenceOne ?? ''}${update.content} ${optionalSentenceTwo ?? ''}${optionalSentenceThree ?? ''}`
                    // }
                })
            })
        }
    }

}